import React, { FC, useEffect, useState } from 'react';
import { CurrentState } from '../containers/CurrentState';
import { SandboxQueue } from '../containers/SandboxQueue';
import { getStatus } from '../api/requests';

interface Task {
  id: string;
  actor: string;
  branchName: string;
  addedAt: string;
}

export interface StatusModel {
  currentStatus: string;
  currentTask?: Task;
  sandboxQueue: {
    elements: any[];
  };
}

export const SandboxPage: FC = () => {
  const [status, setStatus] = useState<StatusModel>();

  useEffect(() => {
    const fetchStatus = async () => {
      const newStatus = await getStatus();
      setStatus(newStatus);
    };

    fetchStatus().catch(console.error);

    const interval = setInterval(async () => {
      fetchStatus().catch(console.error);
    }, 5000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return <div>
    <div className="header">
      <h1>Sandbox</h1>
    </div>

    <div className="content">
      <div className="pure-g">
        <CurrentState status={status}/>
        <SandboxQueue currentRunningTask={status?.currentTask?.id} queue={status?.sandboxQueue}/>
      </div>
    </div>
  </div>;
};
